"use client";

import { createContext, type ReactNode, useContext } from "react";
import { useAuthenticationStatus, useUserData } from "@/lib/nhost/session-hooks";

export type PublicAuthState = "loading" | "signed-in" | "signed-out";

const PublicAuthContext = createContext<PublicAuthState | undefined>(undefined);

export function PublicAuthProvider({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuthenticationStatus();
  const user = useUserData();

  let state: PublicAuthState = "loading";
  if (isAuthenticated && user && !user.isAnonymous) {
    state = "signed-in";
  } else if (user?.isAnonymous || !isLoading) {
    state = "signed-out";
  }

  return <PublicAuthContext.Provider value={state}>{children}</PublicAuthContext.Provider>;
}

export function usePublicAuthState() {
  const state = useContext(PublicAuthContext);
  if (!state) {
    throw new Error("usePublicAuthState must be used within PublicAuthProvider");
  }
  return state;
}
